/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PrinterFinderListItem } from '@gh/builder-shared';
import { STYLES_FLEX_COLUMN_LAYOUT } from '@gh/core-ui';

@Component({
  selector: 'gh-schedule-supervisors-report-filter-printer-step',
  template: require('./schedule-supervisors-report-filter-printer-step.component.html'),
  styles: [STYLES_FLEX_COLUMN_LAYOUT],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleSupervisorsReportFilterPrinterStepComponent {
  @Input() name: string;
  @Input() printers: PrinterFinderListItem[];
  @Input() printer?: PrinterFinderListItem;

  @Output() find = new EventEmitter<string>();
  @Output() printerChange = new EventEmitter<PrinterFinderListItem>();
}
